<h3>Project changes</h3>
<mat-accordion class="example-headers-align">
    <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
            <mat-panel-title>Nodes created/changed</mat-panel-title>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="createdNodesSource" matSort class="node-table-container mat-elevation-z8">
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let node">
                    <app-node-svg [type]="node.type"/>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let node">{{node.name}}</td>
            </ng-container>
            
            <ng-container matColumnDef="field">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Attribute </th>
                <td mat-cell *matCellDef="let node"> {{node.field}} </td>
            </ng-container>
    
            <ng-container matColumnDef="before">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Before </th>
                <td mat-cell *matCellDef="let node"> {{node.before}} </td>
            </ng-container>       

            <ng-container matColumnDef="after">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> After </th>
                <td mat-cell *matCellDef="let node"> {{node.after}} </td>
            </ng-container>       

            <tr mat-header-row *matHeaderRowDef="createdNodesColumns; sticky: true"></tr>
            <tr mat-row (click)="selectNode(row)"  *matRowDef="let row; columns: createdNodesColumns;"></tr>
        </table>
    </mat-expansion-panel>
    <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
            <mat-panel-title>Deleted nodes</mat-panel-title>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="deletedNodesSource" matSort class="node-table-container mat-elevation-z8">
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let node">
                    <app-node-svg [type]="node.type"/>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let node">{{node.name}}</td>
            </ng-container>               

            <tr mat-header-row *matHeaderRowDef="deletedNodesColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: deletedNodesColumns;"></tr>
        </table>
    </mat-expansion-panel>
</mat-accordion>
